// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfig } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeletePhoneNumberToolConfig(): (
  phoneNumberId: string,
  toolId: string,
  key: string
) => Promise<ToolConfig> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId, toolId, key) =>
      (await getAPI()).phonenumbers.deletePhoneNumberToolConfig({
        phoneNumberId,
        toolId,
        key,
      }),
    [getAPI]
  );
}
